import Vue from "vue";
import YarininSuyu from "./YarininSuyu.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import {VueHammer} from "vue2-hammer";
import VueSocialSharing from "vue-social-sharing";
import "@/assets/styles/common-styles.css";
import "@/assets/styles/animate.min.css";

import VueFormWizard from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import VueFormGenerator from 'vue-form-generator'
import 'vue-form-generator/dist/vfg.css'
import VueCarousel from 'vue-carousel';
/* import global-styles */

Vue.use(VueSocialSharing);
Vue.use(VueHammer);
Vue.use(VueFormWizard)
Vue.use(VueFormGenerator)
Vue.use(VueCarousel);
Vue.config.productionTip = false;

const EventBus = new Vue();

export default EventBus;


const defBody = document.createElement('DIV');
defBody.id = "yarinin-suyu";
document.querySelector("body").appendChild(defBody);


new Vue({
    router,
    store,
    VueSocialSharing,
    VueHammer,
    VueFormGenerator,
    render: h => h(YarininSuyu)
}).$mount("#yarinin-suyu");